import React from 'react';
import { Common } from '@stockbit/ui';
import PropTypes from 'prop-types';

import { HeaderContainer } from './styled';

const { Text } = Common;

type HeaderProp = {
  children?: React.ReactNode;
};

const Header: React.FC<HeaderProp> = ({ children }) => (
  <HeaderContainer>
    <Text size="16px" family="bold">
      {children}
    </Text>
  </HeaderContainer>
);

Header.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Header;
